/**
 * Frontend-only onboarding scaffold: no API calls when enabled.
 *
 * Vite: set VITE_ONBOARDING_SCAFFOLD=true in .env
 * Vue CLI / webpack: import.meta.env may be missing — use VUE_APP_ONBOARDING_SCAFFOLD=true
 */
export function isOnboardingScaffoldMode() {
    const viteFlag =
        typeof import.meta !== 'undefined' && import.meta.env
            ? import.meta.env.VITE_ONBOARDING_SCAFFOLD
            : undefined;
    const vueCliFlag =
        typeof process !== 'undefined' && process.env
            ? process.env.VUE_APP_ONBOARDING_SCAFFOLD
            : undefined;

    return viteFlag === 'true' || vueCliFlag === 'true';
}
